import React from 'react'

const icon = ({ className, fill, onClick }) => 
(
    <svg className={className} width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 16.5C14 17.3284 13.3284 18 12.5 18C11.6716 18 11 17.3284 11 16.5C11 15.6716 11.6716 15 12.5 15C13.3284 15 14 15.6716 14 16.5Z" fill="black"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.5 7V11C18.604 11 19.5 11.896 19.5 13V20C19.5 21.103 18.604 22 17.5 22H7.5C6.396 22 5.5 21.103 5.5 20V13C5.5 11.896 6.396 11 7.5 11V7C7.5 4.243 9.743 2 12.5 2C15.257 2 17.5 4.243 17.5 7ZM12.5 4C10.846 4 9.5 5.346 9.5 7V11H15.5V7C15.5 5.346 14.154 4 12.5 4ZM7.5 13V20H17.502L17.5 13H7.5Z" fill="black"/>
    </svg>

)
export default icon


